import React, { Fragment } from 'react'
import 'trix'
import { ReactTrixRTEInput, ReactTrixRTEToolbar } from 'react-trix-rte'

const TrixEditor = (props) => {
  const { defaultValue } = props

  const handleChange = (_event, newValue) => {
    props.contentChangeHandler(newValue)
  }

  const handleAddAttachment = (event) => {
    props.uploadImage(event)
  }

  return (
    <Fragment>
      <ReactTrixRTEToolbar toolbarId='react-trix-rte-editor' />
      <ReactTrixRTEInput
        toolbarId='react-trix-rte-editor'
        defaultValue={defaultValue}
        onChange={handleChange}
        onAttachmentAdd={handleAddAttachment}
        className='trix-content'
      />
    </Fragment>
  )
}

export default TrixEditor
